var map;
var user_markers_layer = new L.FeatureGroup();
var common_markers_layer = new L.layerGroup();
var markers_array = null;
//var all_markers = new L.layerGroup();
var user_markers_array = [];
var nodes;
var polyline;
var tile_main;
var layerControl;
var all_markers = [];
var knowledge_markers = [];
var selected_nodes = new L.FeatureGroup();
var myRenderer = L.canvas({ padding: 0.5 });
var custom_markers = new L.layerGroup();
var last_color='';


function init_map()
{
	var zoom_x = -148;
	var zoom_y = 140;
	var zoom_level = 3;
	var center_x = 17150*4;
	var center_y = 18052*4;

	map = L.map('main', {
		minZoom: 1,
		maxZoom: 9,
		touchZoom: true,
		crs: L.CRS.Simple,
		attributionControl: false,
		fullscreenControl: true,
		fullscreenControlOptions: {
			position: 'topleft'
		}
	}).setView([zoom_x, zoom_y], zoom_level);

	tile_main = L.tileLayer("/zonemap/main/{z}/{x}/{y}.webp", {
		tms: false, noWrap: true, bounds: [[-240, 0], [0, 240]]
	}).addTo(map);

	map.on('zoomend ', function (event)
	{
		//console.log(event.target._zoom);
		update_layer_visibility(event.target._zoom);
	});

	L.control.mousePosition().addTo(map);
	load_markers();

	$('a[data-toggle="tab"]').on('shown.bs.tab', function (e)
	{
		map.invalidateSize(false);
	});

	setup_user_markers();
}


function load_markers()
{
	$.ajax({
		url: "/ajax.php?l=" + lang, dataType: "json", type: "POST", data:
		{
			a: "get_markers",
			atype: get_action(),
			l: lang
		}
	})
	 .then(function (content)
	 {
		 if (content.result == 1)
		 {
			 markers_array = content.data;
			 print_markers();
		 }
	 }, function (xhr, status, error)
	 {
		 console.log("STATUS: " + status + " ERROR: " + error);
	 });
}

function delete_marker(marker_id)
{
	if (user_id > 1)
	{
		$.ajax({
			url: "/ajax.php?l=" + lang, dataType: "json", type: "POST", data: {
				a: "delete_marker", marker_id: marker_id, l: lang
			}
		})
		 .then(function (content)
		 {
			 if (content.result == 1)
			 {
			 }
		 }, function (xhr, status, error)
		 {
			 console.log("STATUS: " + status + " ERROR: " + error);
		 });
	}
}

function update_layers(marker_data, layer_type)
{
	var center = null;
	var marker_cnt = 0;
	for (var zoom in marker_data)
	{
		for (var key in marker_data[zoom])
		{
			var marker = null;
			marker_data[zoom][key].coords = JSON.parse(marker_data[zoom][key].coords);
			if (marker_data[zoom][key].marker_type == 1) //polyline
			{
				marker = new L.polyline(marker_data[zoom][key].coords, {title: marker_data[zoom][key].description});
				center = marker.getBounds().getCenter();
			}
			else if (marker_data[zoom][key].marker_type == 2) //polygon
			{
				marker = new L.polygon(marker_data[zoom][key].coords, {title: marker_data[zoom][key].description});
				center = marker.getBounds().getCenter();
			}
			else if (marker_data[zoom][key].marker_type == 3) //rectangle
			{
				marker = new L.rectangle(marker_data[zoom][key].coords, {title: marker_data[zoom][key].description});
				center = marker.getBounds().getCenter();
			}
			else if (marker_data[zoom][key].marker_type == 4) //circle
			{
				marker = new L.circle(marker_data[zoom][key].coords[0], JSON.parse(marker_data[zoom][key].coords[1]), {title: marker_data[zoom][key].description});
				center = L.latLng(marker_data[zoom][key].coords[0], marker_data[zoom][key].coords[1]);
			}
			else if (marker_data[zoom][key].marker_type == 5) //marker
			{
				marker = new L.marker(marker_data[zoom][key].coords, {
					riseOnHover: true, title: marker_data[zoom][key].description
				});
				center = L.latLng(marker_data[zoom][key].coords[0], marker_data[zoom][key].coords[1]);
			}

			if (marker != null)
			{
				var description = marker_data[zoom][key].description;
				if (description == null) description = 'Marker';
				if (layer_type == 1)
				{
					common_markers_layer.addLayer(marker);
					// if (zoom == 0) common_markers_layer_0.addLayer(marker);
					// else if (zoom == 1) common_markers_layer_1.addLayer(marker);
					// else if (zoom == 2) common_markers_layer_2.addLayer(marker);
					// else if (zoom == 3) common_markers_layer_3.addLayer(marker);
					// else if (zoom == 4) common_markers_layer_4.addLayer(marker);
					//marker.bindTooltip(description, {sticky: false, direction: 'top', permanent: true}).openTooltip();
					marker.bindTooltip(description, {
						sticky: false, direction: 'top', permanent: true, className: 'common_tooltip'
					});
					marker.on('add', function (e)
					{
						e.target.openTooltip();
					});
				}
				else
				{
					user_markers_layer.addLayer(marker);
					var layer_id = user_markers_layer.getLayerId(marker);
					marker.bindPopup(get_popup_text(layer_id, description)).bindTooltip(description, {
						sticky: true, direction: 'top'
					});
					user_markers_array[layer_id] = marker_data[zoom][key];
				}
			}
			marker_cnt++;
		}
	}

	if (layer_type == 1 && center != null && marker_cnt < 4)
	{
		//map.setView(L.latLng(marker_data[key].coords[0], marker_data[key].coords[1]), 5);
		map.setView(center, 5);
	}

}

function get_marker_coords(layer, marker_type)
{
	var coords = [];
	if (marker_type == 1) //polyline
	{
		for (key in layer._latlngs)
		{
			coords.push([layer._latlngs[key].lat, layer._latlngs[key].lng]);
		}
	}
	else if (marker_type == 2) //polygon
	{
		for (key in layer._latlngs[0])
		{
			coords.push([layer._latlngs[0][key].lat, layer._latlngs[0][key].lng]);
		}
	}
	else if (marker_type == 3) //rectangle
	{
		coords.push([layer._bounds._northEast.lat, layer._bounds._northEast.lng], [layer._bounds._southWest.lat, layer._bounds._southWest.lng]);
	}
	else if (marker_type == 4) //circle
	{
		coords.push([layer._latlng.lat, layer._latlng.lng], layer._mRadius);
	}
	else if (marker_type == 5) //marker
	{
		coords.push(layer._latlng.lat, layer._latlng.lng);
	}

	return coords;
}

function get_popup_text(layer_id, description)
{
	var ret_string = '<div class="center_text"><span class="medium_title2">' + msg_marker_description + '</span><br><textarea class="marker_description" id="description_' + layer_id + '">' + description + '</textarea><br><button data-layer_id="' + layer_id + '" class="btn btn-info btn-xs save_description_button" type="button">' + msg_save + '</button> <button data-layer_id="' + layer_id + '" class="btn btn-success btn-xs link_button" type="button" title="' + msg_link + '"><i class="bi bi-paperclip"></i></button>';
	if (user_status == 1) ret_string += '<hr><div class="input-group smallertext"><select class="form-control object_type_input" data-layer_id="' + layer_id + '"><option value="0"></option><option value="1">ZONE</option><option value="2">NPC</option></select><input type="text" class="form-control input-sm object_id_input" data-layer_id="' + layer_id + '" name="counter" size="10" maxlength="10"></div>';
	ret_string += '</div>';
	return ret_string;
}


$.fn.slideFadeToggle = function (easing, callback)
{
	return this.animate({opacity: 'toggle', height: 'toggle'}, 'fast', easing, callback);
};

function update_layer_visibility(zoom)
{
	// console.log('zoom is: '+zoom);
	//layerControl._layers[0].layer._layers[id].openTooltip()
	for (var i in all_markers)
	{
		// console.log(all_markers[i]);
		var id = layerControl._layers[0].layer.getLayerId(all_markers[i]);
		// console.log(id);
		var cp = '';
		if (markers_array['nodes'][i][5] > 0) cp = ' (' + markers_array['nodes'][i][5] + ')';

		var divicon = L.divIcon({
			className: 'marker_icon_block',
			html: '<img src="/images/node_icons/icon_node_' + markers_array['nodes'][i][2] + '.webp" class="marker_icon"><div class="marker_title">' + markers_array['nodes'][i][1] + cp + '</div>',
			iconSize: [30, 34],
			iconAnchor: [15, 15],
			popupAnchor: [0, -15],
			labelAnchor: [15, 0]
		});

		var common_icon = L.icon({
			iconUrl: "/images/node_icons/icon_node_" + markers_array['nodes'][i][2] + ".webp",
			iconSize: [25, 27],
			iconAnchor: [15, 15],
			popupAnchor: [0, -15],
			labelAnchor: [15, 0]
		});

		var icon = common_icon;
		if (zoom > 4 || markers_array['nodes'][i][2] == 2) icon = divicon;

		for (var li = 0; li < 3; li++)
		{
			if (layerControl._layers[li].layer.hasLayer(all_markers[i]))
			{
				layerControl._layers[li].layer._layers[id].setIcon(icon);
				break;
			}
		}
	}
}

function print_markers()
{
	var baseMaps = {};
	baseMaps['main'] = tile_main;
	var names = [];
	all_markers = [];

	var main_nodes = new L.layerGroup();
	var secondary_nodes = new L.layerGroup();
	var production_nodes = new L.layerGroup();
	var node_connections = new L.layerGroup();
	var knowledge = new L.layerGroup();
	var fishing_areas = new L.layerGroup();
	var marker;
	var center;

	for (var i in markers_array['nodes'])
	{
		var markerLocation = map.unproject(markers_array['nodes'][i][0], map.getMaxZoom());
		center = L.latLng(markerLocation);

		var cp = '';
		if (markers_array['nodes'][i][5] > 0) cp = ' (' + markers_array['nodes'][i][5] + ')';

		var divicon = L.divIcon({
			className: 'marker_icon_block',
			html: '<img src="/images/node_icons/icon_node_' + markers_array['nodes'][i][2] + '.webp" class="marker_icon"><div class="marker_title">' + markers_array['nodes'][i][1] + cp + '</div>',
			iconSize: [30, 34],
			iconAnchor: [15, 15],
			popupAnchor: [0, -15],
			labelAnchor: [15, 0]
		});

		var common_icon = L.icon({
			iconUrl: "/images/node_icons/icon_node_" + markers_array['nodes'][i][2] + ".webp",
			iconSize: [25, 27],
			iconAnchor: [15, 15],
			popupAnchor: [0, -15],
			labelAnchor: [15, 0]
		});

		var icon = common_icon;
		if (markers_array['nodes'][i][2] == 2) icon = divicon;

		marker = new L.Marker(markerLocation, {
			icon: icon, riseOnHover: true
		});

		if (markers_array['nodes'][i][2] == 2)
		{
			marker.setZIndexOffset(900);
		}

		marker.bindTooltip('ID: ' + markers_array['nodes'][i][4] + '<br>' + markers_array['nodes'][i][1] + cp + markers_array['nodes'][i][6], {
			sticky: false, direction: 'top', permanent: false, className: 'marker_tooltip'
		});

		if (markers_array['nodes'][i][3] == 1)
		{
			if (markers_array['nodes'][i][2] == 1 || markers_array['nodes'][i][2] == 2)
			{
				main_nodes.addLayer(marker);
			}
			else secondary_nodes.addLayer(marker);
		}
		else production_nodes.addLayer(marker);

		all_markers[i] = marker;

		names.push({
			'name': markers_array['nodes'][i][1],
			'icon': 'icon_node_' + markers_array['nodes'][i][2] + '.webp',
			'icon_path': 'images/node_icons',
			'object_type': markers_array['msgs'][5],
			'data_type': 1,
			'id': i
		});
	}

	for (var item_id in markers_array['products'])
	{
		names.push({
			'name': markers_array['products'][item_id]['data'][1],
			'icon': markers_array['products'][item_id]['data'][0],
			'icon_path': 'items',
			'object_type': markers_array['msgs'][6],
			'data_type': 2,
			'id': item_id
		});
	}

	if (typeof markers_array['fa']!=='undefined')
	{
		for (var color_idx in markers_array['fa'])
		{
			for (var area_idx in markers_array['fa'][color_idx][1])
			{
				var marker_pos = [];
				for (var point_idx in markers_array['fa'][color_idx][1][area_idx][0])
				{
					marker_pos.push(map.unproject(markers_array['fa'][color_idx][1][area_idx][0][point_idx], map.getMaxZoom()));
				}

				marker = new L.polygon(marker_pos, {bubblingMouseEvents: true, color: markers_array['fa'][color_idx][0]});
				marker.on('mouseover', function (e)
				{
					 // console.log(this);
					this.bringToFront();
					last_color=this.options.color;
					this.setStyle({'color':'cyan'});
				});
				marker.on('mouseout', function (e)
				{
					// this.bringToBack();
					this.setStyle({'color':last_color});
				});

				// marker.bindTooltip(\'<img src="\'+locations[tid]["data"][1]+\'" class="wm_marker_icon_sm image-text" alt="icon">\'+locations[tid]["data"][0], {permanent: true, direction: "center", riseOnHover: true, className: "polygon_tooltip map_tooltip_lv_3"});
				fishing_areas.addLayer(marker);
			}
		}
	}



	if (get_action()=='worldmap')
	{
		if (typeof markers_array['knowledge']!=='undefined')
		{
			for (let i in markers_array['knowledge'])
			{
				let markerLocation = map.unproject(markers_array['knowledge'][i][0], map.getMaxZoom());
            	let tooltip='';
				let all_ok=true;
				let marker_color = 'red';
				let sep='';
				for (let idx in markers_array['knowledge'][i][1])
				{
					let square_color = 'red';
					let kn=markers_array['knowledge'][i][1][idx];

					let knowledge_id = kn[2];
					if (typeof sk !== 'undefined' && typeof sk[knowledge_id] !== 'undefined' && sk[knowledge_id][0] == 1) square_color = '#2c8ffd';
					else all_ok=false;
					tooltip+=sep+'<div style="width:10px;height:10px;background-color:'+square_color+';display:inline-block;"></div> '+markers_array['msgs'][8]+': ' + kn[3]+ ' ('+kn[2]+')<br>'+kn[4]+'<br>NPC: ' + kn[1] + ' ('+kn[0]+') '+markers_array['msgs'][9]+': '+kn[5];
					if (sep=='') sep='<hr class="tooltiphr">';
				}
				if (all_ok) marker_color = '#2c8ffd';
				let marker = new L.circleMarker(markerLocation, {radius: 5, color: marker_color, fillColor: marker_color, fillOpacity: 0.5, riseOnHover: true, renderer: myRenderer});
				marker.bindTooltip(tooltip,{sticky: false, direction: 'top', permanent: false, riseOnHover: true, className: 'marker_tooltip_dark'});

				//marker.on('click', toggle_knowledge_marker);
				// marker.knowledge_idx=i;

				knowledge.addLayer(marker);

				//knowledge_markers[i] = marker;
			}
		}
	}


	var latlngs = [];
	for (i = 0; i < markers_array['plinks'].length; i++)
	{
		var line = [map.unproject(markers_array['plinks'][i][0], map.getMaxZoom()), map.unproject(markers_array['plinks'][i][1], map.getMaxZoom())];
		latlngs.push(line);
	}

	var ppolyline = L.polyline(latlngs, {color: 'green'});
	production_nodes.addLayer(ppolyline);

	latlngs = [];
	for (i = 0; i < markers_array['links'].length; i++)
	{
		line = [map.unproject(markers_array['links'][i][0], map.getMaxZoom()), map.unproject(markers_array['links'][i][1], map.getMaxZoom())];
		latlngs.push(line);
	}

	node_connections = L.polyline(latlngs, {color: 'cyan'});

	var layer_groups = {};
	layer_groups[markers_array['msgs'][1]] = main_nodes;
	layer_groups[markers_array['msgs'][2]] = secondary_nodes;
	layer_groups[markers_array['msgs'][3]] = production_nodes;
	layer_groups[markers_array['msgs'][4]] = node_connections;
	if (get_action()=='worldmap')
	{
		layer_groups[markers_array['msgs'][7]] = knowledge;
	}

	if (typeof markers_array['fa']!=='undefined')
	{
		layer_groups['fish'] = fishing_areas;
	}

	var overlays = {};
	overlays[markers_array['msgs'][0]] = layer_groups;

	layerControl = L.control.groupedLayers(null, overlays, {collapsed: false});
	map.addControl(layerControl);


	$('.leaflet-control-layers-selector:checkbox')[0].click();
	$('.leaflet-control-layers-selector:checkbox')[1].click();
	// $('.leaflet-control-layers-selector:checkbox')[3].click();

	sidebar = L.control.sidebar({
		autopan: false,       // whether to maintain the centered map point when opening the sidebar
		closeButton: true,    // whether t add a close button to the panes
		container: 'wm-sidebar', // the DOM container or #ID of a predefined sidebar container that should be used
		position: 'left',     // left or right
	}).addTo(map);
	$('#wm-sidebar').show();


	var mapsource = new Bloodhound({
		datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
		queryTokenizer: Bloodhound.tokenizers.whitespace,
		local: names,
		limit: Infinity
	});

	mapsource.initialize();

	$('.typeahead-map').typeahead({
		classNames: {
			open: 'wm-open',
			menu: 'wm-menu',
			query: 'wm-query',
			cursor: 'wm-cursor',
			suggestion: 'wm-suggestion',
		},
		hint: true, highlight: true, minLength: 2
	}, {
		name: 'matched-links', displayKey: 'name', limit: Infinity, source: mapsource.ttAdapter(), templates:
			{
				empty: null, //suggestion: Handlebars.compile('<p><a href="{{link}}" class="qtooltip" data-id="{{link_type}}--{{value}}"{{link_addon}}><img src="/{{icon_path}}/{{icon}}" class="image-text" alt="icon" width="30px" height="30px"> <span class="item_grade_{{grade}}">{{name}}</span><span class="object_type">{{object_type}}</span></a></p>')
				suggestion: Handlebars.compile('<p><img src="/{{icon_path}}/{{icon}}" class="image-text" alt="icon" width="30px" height="30px"> <span class="">{{name}}</span><span class="object_type">{{object_type}}</span></p>')
			}
	});

	$('.typeahead-map').on('typeahead:selected', function (e, datum)
	{
		select_markers(datum);
	});
}

function toggle_knowledge_marker(e)
{
	let knowledge = markers_array['knowledge'][this.knowledge_idx * 1];
	let tid = knowledge[3];
	if (e.originalEvent.altKey)
	{
		window.open('/'+lang+'/theme/'+tid+'/');
	}
	else
	{
		// console.log(this);
		// console.log(this.knowledge_idx);
		// console.log(tid);
		let marker_color = 'red';
		// console.log(knowledge_markers[this._leaflet_id]);
		if (typeof sk !== 'undefined')
		{
			if (typeof sk[tid] === 'undefined')
			{
				sk[tid] = [1, 0];
				marker_color = '#2c8ffd';
			} else
			{
				delete sk[tid];
				marker_color = 'red';
			}
			this.setTooltipContent('<div style="width:10px;height:10px;background-color:' + marker_color + ';display:inline-block;"></div> Знание: ' + knowledge[4] + ' (' + knowledge[3] + ')<br>' + knowledge[5] + '<br>NPC: ' + knowledge[2] + ' (' + knowledge[1] + ')');
			this.setStyle({color: marker_color});
			this.setStyle({fillColor: marker_color});
		}
		delay(function ()
		{
			save_knowledge();
		}, 1000);
	}
}


function filter_markers(query, force_update)
{
	var query_parts = query.split(' ');
	var is_ok = true;
	for (var i in layerControl._layers[0].layer._layers)
	{
		//console.log(layerControl._layers[0].layer._layers[key]._tooltip._content);
		// map.panTo(layerControl._layers[0].layer._layers[key]._latlng);
		// break;
		if (query.length >= 2)
		{
			var name = layerControl._layers[0].layer._layers[i]._tooltip._content.toLowerCase();
			for (var key in query_parts)
			{
				if ((name != null && name.search(query_parts[key].toLowerCase()) > -1))
				{
				}
				else is_ok = false;
			}
			if (is_ok)
			{
				// var markerLocation = currentmap.unproject(locations["npcs"][i][0], currentmap.getMaxZoom());
				// marker = new L.Marker(markerLocation, {riseOnHover: true, renderer: myRenderer});
				// marker.bindPopup(locations["npcs"][i][1]);
				// marray.addLayer(marker);
				console.log(name);
			}
		}
	}

	return;

	if ((prev_query != query && typeof locations != 'undefined') || force_update)
	{
		if (query.length >= 3 || query == '')
		{
			marray.clearLayers();
			var query_parts = query.split(' ');

			var myIcon = L.icon({
				iconUrl: "/images/marker_green.webp", iconSize: [25, 36], iconAnchor: [12, 36], popupAnchor: [0, -25],
			});

			if ($("#npcs_markers").is(":checked") || (!$("#npcs_markers").is(":checked") && !$("#objects_markers").is(":checked")))
			{
				if (typeof locations["npcs"] != "undefined")
				{
					for (var i = 0; i < locations["npcs"].length; i++)
					{
						var name = locations["npcs"][i][1];
						var is_ok = true;
						for (var key in query_parts)
						{
							if ((name != null && name.toLowerCase().search(query_parts[key].toLowerCase()) > -1) || query == '')
							{
							}
							else is_ok = false;
						}
						if (is_ok)
						{
							var markerLocation = currentmap.unproject(locations["npcs"][i][0], currentmap.getMaxZoom());
							marker = new L.Marker(markerLocation, {riseOnHover: true, renderer: myRenderer});
							marker.bindPopup(locations["npcs"][i][1]);
							marray.addLayer(marker);
						}
					}
				}
			}
			if ($("#objects_markers").is(":checked") || (!$("#npcs_markers").is(":checked") && !$("#objects_markers").is(":checked")))
			{
				if (typeof locations["objects"] != "undefined")
				{
					for (var i = 0; i < locations["objects"].length; i++)
					{
						var name = locations["objects"][i][1];
						var is_ok = true;
						for (var key in query_parts)
						{
							if ((name != null && name.toLowerCase().search(query_parts[key].toLowerCase()) > -1) || query == '')
							{
							}
							else is_ok = false;
						}
						if (is_ok)
						{
							var markerLocation = currentmap.unproject(locations["objects"][i][0], currentmap.getMaxZoom());
							marker = new L.Marker(markerLocation, {
								riseOnHover: true,
								renderer: myRenderer,
								icon: myIcon
							});
							marker.bindPopup(locations["objects"][i][1]);
							marray.addLayer(marker);
						}
					}
				}
			}
			currentmap.addLayer(marray);
		}
		prev_query = query;
	}
}

function select_markers(datum)
{
	var marker;
	selected_nodes.clearLayers();
	var pulsingIcon = L.icon.pulse({iconSize: [20, 20], color: 'red'});
	if (datum.data_type == 1)
	{
		//map.setView(all_markers[datum.id]._latlng, 6);
		var id = layerControl._layers[0].layer.getLayerId(all_markers[datum.id]);
		marker = L.marker(all_markers[datum.id]._latlng, {icon: pulsingIcon});
		selected_nodes.addLayer(marker);
	}
	else if (datum.data_type == 2)
	{
		for (var key in markers_array['products'][datum.id]['nodes'])
		{
			marker = L.marker(all_markers[markers_array['products'][datum.id]['nodes'][key]]._latlng, {icon: pulsingIcon}).addTo(map);
			selected_nodes.addLayer(marker);
		}
	}
	selected_nodes.addTo(map);
	map.fitBounds(selected_nodes.getBounds());
}

function setup_user_markers()
{
	map.addLayer(custom_markers);

	map.on("click", function (e)
	{
		if (e.originalEvent.ctrlKey)
		{
			console.log(e.latlng);
			var cmarker = new L.Marker(e.latlng).on("click", markerOnClick);
			custom_markers.addLayer(cmarker);

			var markers_num=0;
			for (var key in custom_markers._layers)
			{
				markers_num++;
			}
			markers_num+='';
			cmarker.bindTooltip(markers_num, {
				sticky: true, direction: 'top', permanent: true, offset: [1,-30]
			});
			update_url_markers();
		}
	});

	// map.on("contextmenu", function (e)
	// {
	// 	var cmarker = new L.Marker(e.latlng).on("contextmenu", markerOnClickMobile);
	// 	custom_markers.addLayer(cmarker);
	// 	update_url_markers();
	// });


	display_user_markers();
}

function markerOnClick(e)
{
	if (e.originalEvent.ctrlKey)
	{
		custom_markers.removeLayer(this._leaflet_id);
		update_url_markers();
	}
}

function markerOnClickMobile(e)
{
	custom_markers.removeLayer(this._leaflet_id);
	update_url_markers();
}


function get_markers()
{
	var center_x = 17150*4;
	var center_y = 18052*4;
	var coords = "";
	var sep = "";
	for (var k in custom_markers._layers)
	{
		var pixel = map.project(custom_markers._layers[k]._latlng, map.getMaxZoom());
		pixel.x = (pixel.x - center_x) * (100/4);
		pixel.y = (pixel.y - center_y) * (100/4) * -1;
		coords += sep + pixel.x + "," + pixel.y;
		if (sep == "") sep = "|";
	}
	return coords;
}


function update_url_markers()
{
	window.history.replaceState({}, '', '#' + get_markers());
}

function display_user_markers()
{
	var center_x = 17150*4;
	var center_y = 18052*4;
	var regex = /[^0-9\-\,\.\|]/gm;
	var subst = '';
	var user_data = window.location.hash.replace(regex, subst);

	var hash_array = user_data.replace('#', '').split('|');
	for (var key in hash_array)
	{
		var coords = hash_array[key].split(',');
		if (coords.length === 2)
		{
			var point = L.point(center_x + coords[0] / (100/4), center_y + (-1 * coords[1] / (100/4)));
			var markerLocation = map.unproject(point, map.getMaxZoom());
			var cmarker = new L.Marker(markerLocation).on("click", markerOnClick);
			// cmarker.bindTooltip('Marker #'+key, {
			// 	sticky: false, direction: 'top', permanent: true, className: 'common_tooltip'
			// });
			var numb=key*1+1+'';
			cmarker.bindTooltip(numb,
			{
				sticky: true, direction: 'top', permanent: true, offset: [1,-30]
			});
			custom_markers.addLayer(cmarker);
		}
	}
}
